import { ITranslateProps, InjectedFormProps } from 'models/common';
import * as React from 'react';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { RouteComponentProps, browserHistory } from 'react-router';
import { getShop } from 'redux/modules/shop/manageshop';
import { getShopSubscriptionPlans } from 'redux/modules/subscriptionplans/shopsubscriptionplans';
import { ErrorSummary } from 'components';
import { EditableShopSubscription } from '../EditableShopSubscriptionComponent';
import renderIcon from 'helpers/renderIcon';
import moment = require('moment');
import ShopSmsReport from 'containers/Shop/Common/ShopSmsReport';
import { PortalPageSection } from 'components/PortalStructure';
import { AdminSmsIntervalPicker } from '../AdminSmsIntervalPicker';
require('./style.scss');

interface IParams {
	shopId: string;
}

interface IOwnProps extends RouteComponentProps<IParams, {}> {}

interface IProps
	extends InjectedFormProps,
		IOwnProps,
		ReturnType<typeof stateToProps>,
		ReturnType<typeof dispatchToProps>,
		ITranslateProps {}

interface IState {
	addingNewPlan: boolean;
	duplicateLast: boolean;
}

const stateToProps = (state: IStore) => ({
	manageShop: state.manageShop,
	shopSubscriptionPlans: state.shopSubscriptionPlansReducer,
});

const dispatchToProps = (dispatch) => ({
	getShop: (id) => dispatch(getShop(id, false, false, true)),
	getShopSubscriptionPlans: (shopId: string) => dispatch(getShopSubscriptionPlans(shopId)),
});

@connect(stateToProps, dispatchToProps)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminEditShopSubscriptionPlans extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			addingNewPlan: false,
			duplicateLast: false,
		};
	}

	componentDidMount(): void {
		const { params, shopSubscriptionPlans, manageShop, getShopSubscriptionPlans, getShop } = this.props;
		if (manageShop?.shop?.id != params?.shopId) {
			getShop(params?.shopId);
		}

		if (!params?.shopId) {
			browserHistory.push(`/admin/subscriptionplans`);
		}

		if (!shopSubscriptionPlans.shopId || shopSubscriptionPlans?.shopId != params.shopId) {
			getShopSubscriptionPlans(params.shopId);
		}
	}

	public render() {
		const { manageShop, params, shopSubscriptionPlans, t } = this.props;
		const shop = manageShop?.shop;

		return (
			<div className="adminEditShopSubscriptionPlans container">
				<div className="row">
					<div className="col-12">
						<ErrorSummary error={shopSubscriptionPlans.error} message={shopSubscriptionPlans.message} />
						<ErrorSummary error={manageShop.error} message={manageShop.message} />

						<h1 className="adminEditShopSubscriptionPlans__mainTitle">
							{renderIcon('arrow_left', 18, 18, '', () => {
								browserHistory.push('/admin/subscriptionplans');
							})}{' '}
							{shop?.name}
						</h1>

						<AdminSmsIntervalPicker />

						{shop?.currentShopSubscriptionPlan && (
							<PortalPageSection>
								<ShopSmsReport shop={shop} t={t} />
							</PortalPageSection>
						)}
						{!shop?.currentShopSubscriptionPlan && (
							<h5>{t('Admin_AdminSubscriptionPlans_NoActiveSubscriptionPlans')}</h5>
						)}

						{!this.state.addingNewPlan && (
							<div
								className="adminEditShopSubscriptionPlans__new-plan-button"
								onClick={() => this.setState(() => ({ addingNewPlan: true, duplicateLast: false }))}
							>
								{renderIcon('nikaPlus')} {t('Admin_EditShopSubscriptionPlans_NewPlan')}
							</div>
						)}
						{!this.state.addingNewPlan && (
							<div
								className="adminEditShopSubscriptionPlans__new-plan-button"
								onClick={() => this.setState(() => ({ addingNewPlan: true, duplicateLast: true }))}
							>
								{renderIcon('nikaPlus')} {t('Admin_EditShopSubscriptionPlans_ExtendLastPlan')}
							</div>
						)}

						{this.state.addingNewPlan && (
							<div className="adminEditShopSubscriptionPlans__new-plan">
								<EditableShopSubscription
									isNewSubscription={true}
									shopId={params.shopId}
									onCancelNew={() => this.setState({ addingNewPlan: false })}
									onFinish={() => this.setState({ addingNewPlan: false })}
									shopSubscriptionPlan={
										this.state.duplicateLast &&
										this.props.shopSubscriptionPlans?.shopPlans?.reduce(
											(a, b) => (a && b && moment(a.validTo).unix() > moment(b.validTo).unix() ? a : b),
											null,
										)
									}
								/>
							</div>
						)}

						<div className="adminEditShopSubscriptionPlans__all-plans">
							{this.props.shopSubscriptionPlans?.shopPlans?.map((plan) => (
								<EditableShopSubscription
									key={plan?.id}
									shopSubscriptionPlan={plan}
									shopId={params.shopId}
									onFinish={() => this.props.getShop(params.shopId)}
								/>
							))}
							{!this.props.shopSubscriptionPlans?.shopPlans?.length && (
								<h2>{t('Admin_EditShopSubscriptionPlans_NoPlans')}</h2>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { AdminEditShopSubscriptionPlans };
